module.exports = __webpack_public_path__ + "img/54c5989ec7bc8b192c60f9e9a0dae937.ec930bc5.jpg";